import BaseDropdown from "@common/components/Dropdown/Dropdown";
import { vars } from "@common/styles";
import styled from "styled-components";

export const Dropdown = styled(BaseDropdown)`
  background: ${vars.colors.grey100};
  border: 1px solid ${vars.colors.grey90};
  border-radius: 1rem;

  > div:first-child {
    padding: 1rem;
  }

  span {
    text-color: ${vars.colors.grey30};
    white-space: nowrap;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1.4rem;
`;
